(function() {
    angular
        .module("globalArrowBoardMapModule", [
            "ui.router",
            "googlechart",
        ])
})()
